export const dCred = {
  param: "?slug=",
};
